/**
 * @file reducers/Search/reducer.js
 */
import { createSlice } from "@reduxjs/toolkit";

const searchSlice = createSlice({
    name: "search",
    initialState: {},
    reducers: {
        // Content was received for an initial search via the API. We need to update the search state accordingly.
        receive_search_results: (state, action) => {
            if (Array.isArray(action.payload.json)) {
                return {
                    ...state,
                    results: action.payload.json,
                    section: action.payload.params.section,
                    searchTerm: action.payload.params.searchTerm,
                    sortOrder: action.payload.params.sortOrder,
                    resultCount: action.payload.params.resultCount,
                    infoCard: action.payload.params.infoCard,
                    pageNum: action.payload.params.pageNum,
                    media: action.payload.params.media,
                };
            }
        },
        // Receive Top Video results via API to render in video swimlane
        receive_top_video_results: (state, action) => {
            if (action.payload.json instanceof Object) {
                return {
                    ...state,
                    video_results: {
                        items: action.payload.json,
                    },
                };
            }
        },
        // Content was received for the next page of a search via the API. We need to update the search state accordingly.
        update_search_results: (state, action) => {
            if (Array.isArray(action.payload.json)) {
                const results = state.results.concat(action.payload.json);
                return {
                    ...state,
                    results: results,
                    pageNum: action.payload.params.pageNum,
                };
            }
        },
        receive_autocomplete_results: (state, action) => {
            if (Array.isArray(action.payload.json)) {
                return {
                    ...state,
                    autocompleteResults: action.payload.json,
                };
            }
        },
        clear_search_results: () => {
            return {};
        },
    },
});

export const {
    receive_search_results,
    receive_top_video_results,
    update_search_results,
    receive_autocomplete_results,
    clear_search_results,
} = searchSlice.actions;
export default searchSlice.reducer;
